// Ciência nos Termos de Uso pela matriz e pelas SPEs do rateio. Com o rateio, as
// SPEs passam a ser corresponsáveis pelo pagamento: a matriz (admin do tenant) e
// cada SPE (representante legal) aderem aos Termos por um link enviado por e-mail.
// Espelha TermsAcceptanceStatusDto / PublicTermsAcceptanceDto da api.

export enum TermsAcceptanceStatusEnum {
  Pending = 1,
  Accepted = 2,
  // Substituído por um pedido mais novo.
  Superseded = 3,
  // Travado após tentativas com CPF incorreto.
  Locked = 4,
}

export interface ITermsAcceptanceResponse {
  Status: TermsAcceptanceStatusEnum;
  // Pendente, mas com o link vencido: é preciso reenviar.
  IsExpired: boolean;
  RecipientName: string;
  RecipientEmail: string;
  RequestedAtUtc: string;
  // Nulo se o e-mail não saiu.
  EmailSentAtUtc?: string | null;
  AcceptedAtUtc?: string | null;
  AcceptedName?: string | null;
}

// O que a página pública do link mostra.
export interface IPublicTermsAcceptanceResponse {
  IsHeadquarters: boolean;
  CompanyName: string;
  CompanyDocument?: string | null;
  RecipientName: string;
  TermsUrl: string;
  TermsVersion: string;
  Status: TermsAcceptanceStatusEnum;
  IsExpired: boolean;
  AcceptedAtUtc?: string | null;
}

export interface IAcceptTermsRequest {
  name: string;
  cpf: string;
  accepted: boolean;
}
